import React, { useEffect, useState } from "react";
import { View, Text, TouchableOpacity, StyleSheet, Modal } from "react-native";
import toast from "react-hot-toast";
import Button from "../Button/Button";
import TextInputTopLabel from "../Other/TextInput";
import { primaryDark, headerPurple } from "../../Constants/Colors";

const ContactUsModal = ({ onClose, onSubmit }) => {
  const [email, setEmail] = useState("");
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
  }, []);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSend = () => {
    // Validate email
    if (!email.trim()) {
      toast.error("Please enter your email address");
      return;
    }

    if (!validateEmail(email.trim())) {
      toast.error("Please enter a valid email address");
      return;
    }

    // Validate title
    if (!title.trim()) {
      toast.error("Please enter an inquiry title");
      return;
    }

    // Validate message
    if (!message.trim()) {
      toast.error("Please enter your message");
      return;
    }

    // All validations passed
    toast.success("Inquiry sent successfully!", {
      duration: 4000
    });
    onSubmit && onSubmit({ email: email.trim(), title: title.trim(), message: message.trim() });
    setEmail("");
    setTitle("");
    setMessage("");
    onClose && onClose();
  };

  return (
    <Modal visible={visible} transparent animationType="fade" onRequestClose={onClose}>
      <View style={styles.overlay}>
        <View style={styles.gradientBg}>
          <View style={styles.modalBox}>
            {/* Close Button */}
            <TouchableOpacity style={styles.closeButton} onPress={onClose}>
              <Text style={styles.closeText}>✕</Text>
            </TouchableOpacity>

            {/* Icon */}
            <View style={styles.iconCircle}>
              <Text style={styles.iconText}>📧</Text>
            </View>

            <Text style={styles.heading}>Let’s elevate your business</Text>
            <Text style={styles.subheading}>Tell us what you need.</Text>
            <TextInputTopLabel
              value={email}
              onChangeText={setEmail}
              placeholder="Enter Email"
              type="email"
              autoFocus={false}
              containerStyle={{ marginBottom: 30, width: "100%" }}
            />
            <TextInputTopLabel
              value={title}
              onChangeText={setTitle}
              placeholder="Enter Inquiry Title"
              type="text"
              autoFocus={false}
              containerStyle={{ marginBottom: 30, width: "100%" }}
            />
            <TextInputTopLabel
              value={message}
              onChangeText={setMessage}
              placeholder="Enter Explanation"
              type="text"
              multiline
              containerStyle={{ marginBottom: 30, width: "100%" }}
            />
            <Button
              title="Send Inquiry"
              onPress={handleSend}
              variant="purple"
              size="large"
              style={{ marginTop: 8, width: "100%" }}
            />
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: "rgba(0,0,0,0.7)",
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
  },
  gradientBg: {
    width: "100%",
    maxWidth: 600,
    borderRadius: 24,
    padding: 2,
    backgroundColor: "linear-gradient(135deg, #8B5CF6 0%, #C4A5FF 100%)",
    shadowColor: "rgba(139,92,246,0.18)",
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 0.18,
    shadowRadius: 32,
    elevation: 12,
  },
  modalBox: {
    backgroundColor: "#fff",
    borderRadius: 22,
    padding: 36,
    position: "relative",
    shadowColor: headerPurple,
    shadowOffset: { width: 0, height: 12 },
    shadowOpacity: 0.18,
    shadowRadius: 32,
    elevation: 12,
    alignItems: "center",
  },
  closeButton: {
    position: "absolute",
    top: 18,
    right: 18,
    zIndex: 10,
    width: 36,
    height: 36,
    borderRadius: 18,
    backgroundColor: "#F3F4F6",
    alignItems: "center",
    justifyContent: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.12,
    shadowRadius: 4,
    elevation: 2,
  },
  closeText: {
    fontSize: 22,
    fontWeight: "700",
    color: headerPurple,
  },
  iconCircle: {
    width: 64,
    height: 64,
    borderRadius: 32,
    backgroundColor: "#F3F4F6",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 18,
    shadowColor: headerPurple,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.12,
    shadowRadius: 4,
    elevation: 2,
  },
  iconText: {
    fontSize: 32,
    color: headerPurple,
  },
  heading: {
    fontSize: 30,
    fontWeight: "800",
    color: headerPurple,
    textAlign: "center",
    marginBottom: 8,
    letterSpacing: -1,
  },
  subheading: {
    fontSize: 16,
    color: "#6B7280",
    textAlign: "center",
    marginBottom: 24,
    opacity: 0.85,
  },
});

export default ContactUsModal;
